import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, active, delay = 0, y = 26, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={`reveal ${className}`}
      initial={reduce ? false : { opacity: 0, y }}
      animate={active ? { opacity: 1, y: 0 } : reduce ? { opacity: 1 } : { opacity: 0, y }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </MotionTag>
  );
};

export const MaskLines = ({ lines, active, delayBase = 0.15, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" style={{ paddingBottom: "0.02em" }}>
          <motion.span
            className="reveal block"
            initial={reduce ? false : { y: "110%" }}
            animate={active ? { y: "0%" } : reduce ? { y: "0%" } : { y: "110%" }}
            transition={{ duration: 0.9, delay: delayBase + i * 0.12, ease: EASE }}
            aria-hidden="true"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
